// Client-side short-code generator. The backend is the authority on uniqueness
// — this is shown in the form as a preview so the operator sees their short
// URL before they hit Create. Base62, length 6 (~57 billion codes).

const BASE62 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const SLUG_LENGTH = 6;

const SLUG_RE = new RegExp(`^[${BASE62}]{${SLUG_LENGTH}}$`);

export function generateSlug(len = SLUG_LENGTH): string {
  // Prefer crypto.getRandomValues for unbiased picks; fall back to Math.random
  // in environments that lack it (older test envs).
  const buf = new Uint32Array(len);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(buf);
  } else {
    for (let i = 0; i < len; i += 1) buf[i] = Math.floor(Math.random() * 0xffffffff);
  }
  let s = '';
  for (let i = 0; i < len; i += 1) s += BASE62[buf[i] % BASE62.length];
  return s;
}

export function isValidSlug(s: string): boolean {
  return SLUG_RE.test(s);
}

export const SHORT_DOMAIN = process.env.REACT_APP_SHORT_DOMAIN || 'link.xnotify.com';

export function buildShortUrl(slug: string): string {
  return `https://${SHORT_DOMAIN}/${slug}`;
}

/**
 * SM_011: the Create-form preview must match the short_url the API actually
 * returns. When the tenant has an ACTIVE custom domain the backend serves the
 * link host-only (https://custom.domain/<slug>); otherwise it uses the platform
 * domain WITH the tenant-slug path segment (https://link.xnotify.com/<tenant>/<slug>).
 * One string is used for both the field and the help text so they never diverge.
 */
export function buildPreviewShortUrl(
  slug: string,
  tenantSlug: string,
  customDomain?: string | null,
): string {
  if (customDomain) return `https://${customDomain}/${slug}`;
  return `https://${SHORT_DOMAIN}/${tenantSlug}/${slug}`;
}
